import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { metricConversions as metricConversionsSelector } from 'modules/Account/selectors';
export const useConversion = (metric)=>{
    const metricConversions = useSelector(metricConversionsSelector);
    return useMemo(()=>metricConversions[metric], [
        metricConversions,
        metric
    ]);
};
